import React, { lazy } from "react";

const LazyEditAssessment = lazy(() => import("./EditAssessment"));

const EditAssessment = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode }
) => <LazyEditAssessment {...props} />;

export default EditAssessment;
